import { Modal, ModalBody, ModalHeader } from 'react-bootstrap';
import Certificate from '../../Pages/admin/Events/certificate-builder/Certificate/Certificate';

export default function CertificateModal({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} size="lg" fullscreen>
      <ModalHeader closeButton>
        <h3>Certificate</h3>
      </ModalHeader>
      <ModalBody>
        <Certificate preview={true} />
      </ModalBody>
    </Modal>
  );
}
